<template>
    <div class="row">
    <div class="col-12 btn-final transition_on txt-right mrg-top-30">
      <div class="navegation" :class="[size && `pagination-${size}`, align && `justify-content-${align}`]">
        <a class="prev cursor-pointer"  @click="prevPage" :class="{disabled: pagination.page === 1}"><</a>
        <span :class="{active: pagination.page === item}" class="cursor-pointer" :key="item"
    v-for="item in range(minPage, maxPage)"  @click="changePage(item)">{{item}}</span>
        <a class="next cursor-pointer" @click="nextPage" :class="{disabled: pagination.page === totalPages}">></a>
      </div>
    </div>
  </div>
<!--   <ul class="pagination" :class="[size && `pagination-${size}`, align && `justify-content-${align}`]">
    <li class="page-item prev-page" :class="{disabled: pagination.page === 1}">
      <a class="page-link" aria-label="Previous" @click="prevPage">
        <span aria-hidden="true"><i class="fa fa-angle-left" aria-hidden="true"></i></span>
      </a>
    </li>
    <li class="page-item" :class="{active: pagination.page === item}"
    :key="item"
    v-for="item in range(minPage, maxPage)">
    <a class="page-link" @click="changePage(item)">{{item}}</a>
  </li>
  <li class="page-item next-page" :class="{disabled: pagination.page === totalPages}">
    <a class="page-link" aria-label="Next" @click="nextPage">
      <span aria-hidden="true"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
    </a>
  </li>
</ul> -->
</template>
<script>
  export default {
    name: "base-pagination",
    props: {
      size: {
        type: String,
        default: "",
        description: "Pagination size"
      },
      align: {
        type: String,
        default: "",
        description: "Pagination alignment (e.g center|start|end)"
      },
      pagination:{
       type: Object,
       default: ()=>{},
     }
   },
   computed: {
    totalPages() {
      if (this.pagination.last_page > 0) return this.pagination.last_page;
      if (this.pagination.total > 0) {
        return Math.ceil(this.pagination.total / this.pagination.per_page);
      }
      return 1;
    },
    pagesToDisplay() {
      if (this.totalPages > 0 && this.totalPages < this.defaultPagesToDisplay) {
        return this.totalPages;
      }
      return this.defaultPagesToDisplay;
    },
    minPage() {
      if (this.pagination.page >= this.pagesToDisplay) {
        const pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        const newMaxPage = pagesToAdd + this.pagination.page;
        if (newMaxPage > this.pagination.totalPages) {
          return this.pagination.totalPages - this.pagesToDisplay + 1;
        }
        return this.pagination.page - pagesToAdd;
      } else {
        return 1;
      }
    },
    maxPage() {
      if (this.pagination.page >= this.pagesToDisplay) {
        const pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        const newMaxPage = pagesToAdd + this.pagination.page;        
        if (newMaxPage < this.totalPages) {
          return newMaxPage;
        } else {
          return this.totalPages;
        }
      } else {
        return this.pagesToDisplay;
      }
    }
  },
  data() {
    return {
      defaultPagesToDisplay: 5
    };
  },
  methods: {
    range(min, max) {
      let arr = [];
      for (let i = min; i <= max; i++) {
        arr.push(i);
      }
      return arr;
    },
    changePage(item) {
      this.pagination.page = item;
      this.$emit("change");
    },
    nextPage() {
      if (this.pagination.page < this.totalPages) {
        this.pagination.page = this.pagination.page + 1
        this.$emit("change");
      }
    },
    prevPage() {
      if (this.pagination.page > 1) {
        this.pagination.page = this.pagination.page - 1;
        this.$emit("change");
      }
    }
  },
  watch: {
    // pagination.per_page() {
    //   this.$emit("input", 1);
    // },
    // pagination.total() {
    //   this.$emit("input", 1);
    // }
  }
};
</script>
<style type="text/css" scoped>
  
  .navegation span {
    background: var(--cor-cinza-escuro);
    color: var(--cor-branco);
    border-radius: 100px;
    margin: 5px;
    height: 50px;
    width: 50px;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    font-size: 27px;
    font-family: var(--font-oswald);
}
  .navegation span.active {
    background: var(--cor-azul-escuro);
    color: var(--cor-branco);
    border-radius: 100px;
    margin: 5px;
    height: 50px;
    width: 50px;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    font-size: 27px;
    font-family: var(--font-oswald);
}
</style>
